import { render, staticRenderFns } from "./CustomAddons.vue?vue&type=template&id=cbd5aa0c"
import script from "./CustomAddons.vue?vue&type=script&lang=js"
export * from "./CustomAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports